import {useEffect} from "react";
import {Column} from "components";
import {Header, Table} from "./lib";
import {get} from "global/slices/payments/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import {initialState} from "global/slices/payments/initial-state";

interface PaymentsProps {}

export const Payments: React.FC<PaymentsProps> = () => {
  const dispatch = useAppDispatch();
  const {payments} = useAppSelector("payments");
  useEffect(() => {
    if (!payments["length"]) dispatch(get(initialState["pagination"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payments]);

  return (
    <Column>
      <Header />
      <Table />
    </Column>
  );
};
